module.exports = __webpack_public_path__ + "static/media/hamburger_white_icon.7449ed04.svg";